var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9a7 7 0 107 7 7.008 7.008 0 00-7-7zm.146 2.917a.875.875 0 110 1.75.875.875 0 010-1.75zm1.312 7.875h-2.333a.583.583 0 010-1.167h.438c.08 0 .145-.065.145-.146v-2.625a.146.146 0 00-.146-.146h-.437a.583.583 0 110-1.166h.583c.645 0 1.167.522 1.167 1.166v2.771c0 .08.065.146.146.146h.437a.583.583 0 110 1.167z",
    fill: "#0D0C21",
    fillRule: "evenodd"
  })));
}
export default SvgInfo;